import { AlertTriangle, WifiOff } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import { useClientDocumentsConfig } from '@/hooks/useClientDocumentsConfig';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export function ClientStatusBanner() {
  const { user } = useAuthStore();
  const { maintenanceMode, loading } = useClientDocumentsConfig();
  const { apiReachable } = useOnlineStatus();

  const isAdmin = user?.role === 'ADMIN';
  const showMaintenance = !loading && maintenanceMode && !isAdmin;
  const showOffline = !apiReachable;

  if (!showMaintenance && !showOffline) return null;

  return (
    <div className="border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-950">
      {showOffline && (
        <div className="flex items-center gap-2">
          <WifiOff className="h-4 w-4 shrink-0" />
          <span>
            Connessione al server assente o instabile. Le operazioni possono non essere disponibili fino al ripristino.
          </span>
        </div>
      )}
      {showMaintenance && (
        <div className={`flex items-center gap-2 ${showOffline ? 'mt-2 pt-2 border-t border-amber-200' : ''}`}>
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span>Modalità manutenzione attiva: interfaccia in sola lettura per i non amministratori.</span>
        </div>
      )}
    </div>
  );
}
